import { render, staticRenderFns } from "./EmailTemplateUpdate.vue?vue&type=template&id=2a0ba078"
import script from "./EmailTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./EmailTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports